import { useHistory } from "react-router-dom";
import { EmailVerificationNavState } from "../components/molecules/signUpAndLoginPages/EmailVerification";
import { ForgotPasswordNavState } from "../components/molecules/signUpAndLoginPages/ForgotPasswordForm";
import { ForgotPasswordSentNavState } from "../components/molecules/signUpAndLoginPages/ForgotPasswordSent";
import { PlansNavState } from "../pages/Plans";

/**
 * Hook used to navigate between routes that expect a certain state, in a type-safe way
 */
export const useNavigator: () => (props: NavProps) => void = () => {
  const history = useHistory();

  return ({ pathname, state, replace }: NavProps): void => {
    if (replace) history.replace({ pathname, state });
    else history.push({ pathname, state });
  };
};

export type NavProps = { replace?: boolean } & (
  | HomeNavProps
  | ForgotPasswordNavProps
  | ForgotPasswordSentNavProps
  | EmailVerificationNavProps
  | PlansNavProps
);

type ForgotPasswordNavProps = {
  pathname: "/forgot-password";
  state?: ForgotPasswordNavState;
};

type ForgotPasswordSentNavProps = {
  pathname: "/forgot-password-sent";
  state: ForgotPasswordSentNavState;
};

type EmailVerificationNavProps = {
  pathname: "/email-verification";
  state: EmailVerificationNavState;
};

type PlansNavProps = {
  pathname: "/plans";
  state: PlansNavState;
};

type HomeNavProps = {
  pathname: "/";
  state?: {};
};
